import styled from 'vue-styled-components';

export const Wrapper = styled.div`
    padding: 0 16px;
`;
